//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitJoin.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
let d=[[[0,"Associative",1,0],[1,"BlendFace",0,"ScCollector",0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitJoinData",0,"GeometricUtilities.CurveFitJoin",0],[1,"RevolvedFace",0,"ScCollector",0],[1,"TubeFaces",0,"ScCollector",0],[0,"Type",1,0]],[],[]];
SPLM.Features.VirtualCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VirtualCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VirtualCurveBuilder.Types = Object.freeze({
    "RotationAxis" : "RotationAxis", "BlendCenterline" : "BlendCenterline", "VirtualIntersection" : "VirtualIntersection", "TubeCenterline" : "TubeCenterline"});

export default SPLM;